import debounce from 'lodash/debounce'
import type { RouteLocationNormalizedGeneric } from '#vue-router'

export const customScrollBehavior = async (to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) => {
  if (!document || !window) {
    return
  }

  if (!to.hash) {
    return {
      top: 0,
      left: 0,
    }
  }

  const hash = to.hash.substring(1)
  const headerHeight = document.querySelector<HTMLElement>('header')?.offsetHeight || 0
  const offset = headerHeight + 30

  if (!from.name) {
    const manualInteractionEvents = ['mousedown', 'wheel', 'touchstart', 'keydown', 'click']

    let observer: MutationObserver | null = null

    const scrollToElement = () => {
      if (!observer) {
        return
      }

      const elementToScroll = document.getElementById(hash)

      if (!elementToScroll) {
        return
      }

      const elementPosition = elementToScroll.getBoundingClientRect().top || 0
      const offsetPosition = elementPosition + window.scrollY - offset

      window.scrollTo({
        behavior: 'smooth',
        top: offsetPosition,
      })
    }

    const debouncedScrollToElement = debounce(scrollToElement, 800)

    observer = new MutationObserver(() => {
      debouncedScrollToElement()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    })

    const stopObserving = () => {
      if (observer) {
        observer.disconnect()
        observer = null
      }
    }

    const onManualInteraction = () => {
      stopObserving()
      manualInteractionEvents.map(event => window.removeEventListener(event, onManualInteraction))
    }

    manualInteractionEvents.map(event => window.addEventListener(event, onManualInteraction))
  }
  else {
    const elementToScroll = document.getElementById(hash)

    if (!elementToScroll) {
      return
    }

    const elementPosition = elementToScroll.getBoundingClientRect().top || 0
    const offsetPosition = elementPosition + window.scrollY - offset

    return {
      behavior: 'smooth',
      top: offsetPosition,
    }
  }
}
